export enum IntegrationSystems {
  Qmlativ = 3262,
  SMS = 3263,
}
